import {
  WIX_FEE_RATE,
  hasPricingOptions,
  hasSeatingPlan,
  isDonationTicketDefinition,
  isFeeIncluded,
} from '@wix/wix-events-commons-statics'

export const getDemoReservations: (
  event: wix.events.Event,
  ticketDefinitions: wix.events.ticketing.TicketDefinition[],
) => wix.events.ticketing.TicketReservation[] = (event, ticketDefinitions) => {
  const ticketDefinition = ticketDefinitions[0]

  const ticketDetails: wix.events.ticketing.TicketDetails = {
    ...(hasSeatingPlan(event)
      ? {
          seatId: '0-203-12',
          rowNumber: '7',
          seatNumber: '12',
          rowLabel: '7',
          seatLabel: '12',
          planId: 'seating-plan-1',
          capacity: 1,
        }
      : {}),
    ...(hasPricingOptions(ticketDefinition)
      ? {
          pricingOptionId: ticketDefinition.pricing.pricingOptions.options[0].id,
          pricingOptionName: ticketDefinition.pricing.pricingOptions.options[0].name,
          pricingOptionPrice: ticketDefinition.pricing.pricingOptions.options[0].price,
          capacity: 1,
        }
      : {}),
    ...(isDonationTicketDefinition(ticketDefinition) ? {priceOverride: '19.99'} : {}),
  }

  return [
    {
      quantity: 1,
      ticket: ticketDefinition,
      ticketDetails: [ticketDetails],
    },
  ]
}

export const getDemoInvoice: (
  ticketDefinitions: wix.events.ticketing.TicketDefinition[],
) => wix.events.ticketing.Invoice = ticketDefinitions => {
  const ticketDefinition = ticketDefinitions[0]
  const price = ticketDefinition.pricing.fixedPrice ||
    ticketDefinition.pricing.pricingOptions.options[0].price || {
      ...ticketDefinition.price,
      amount: '19.99',
      value: '19.99',
    }

  const taxAmount = (Number(price.amount) * WIX_FEE_RATE).toFixed(2)
  const total = isFeeIncluded(ticketDefinition.wixFeeConfig.type)
    ? price.amount
    : (Number(price.amount) + Number(taxAmount)).toString()

  return {
    total: price,
    subTotal: price,
    grandTotal: {
      amount: total,
      currency: price.currency,
      value: total,
    },
    fees: [
      {
        name: 0,
        type: ticketDefinition.wixFeeConfig.type,
        rate: (WIX_FEE_RATE * 100).toString(),
        amount: {
          amount: taxAmount,
          currency: price.currency,
          value: taxAmount,
        },
      },
    ],
  }
}
